import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { loaderActions } from "../../redux/slices/loadingSlice";
import { useAppDispatch, useAppSelector } from "../../redux/store";
// import newNoticeService from "../../services/NewNoticeService";
import LiveHelpIcon from "@mui/icons-material/LiveHelp";
import { useEffect } from "react";
import LogService from "../../services/LogService";
import { toast } from "react-toastify";
import ApiReq_NewNotice from "../../types/ApiReq_NewNotice";
import newNoticeService from "../../services/NewNoticeService";

const ChatForm = () => {
  const dispatch = useAppDispatch();
  const booking = useAppSelector((state) => state.booking);
  const form = useForm<Partial<ApiReq_NewNotice>>({
    defaultValues: {
      bookingNumber: booking.bookingNumber,
      name: booking.bookingUsername,
      email: "",
      message: "",
      taskType: "",
    },
  });
  const { control, handleSubmit, watch, formState, reset, setError, setValue } =
    form;
  const { errors } = formState;
  const values = watch();

  useEffect(() => {
    setValue("bookingNumber", booking.bookingNumber);
    setValue("name", booking.bookingUsername);
  }, [booking]);

  const onSubmit: SubmitHandler<Partial<ApiReq_NewNotice>> = async (data) => {
    dispatch(loaderActions.showLoader());
    console.log("Form Data:", data);

    // Log message to the database
    await LogService({
      bookingNumber: booking.bookingNumber,
      name: booking.bookingUsername,
      message: "support request succses",
    });

    const response = await newNoticeService(values);

    if (response === null) {
      dispatch(loaderActions.hideLoader());

      toast.error("Please try again later!");

      return;
    }

    dispatch(loaderActions.hideLoader());
    toast.success("We have successfully received your message!");
    reset();
  };

  return (
    <div className="p-6 bg-white rounded-lg shadow-lg w-full lg:m-auto">
      <h6 className="text-xl font-bold text-gray-600 mb-4 border-b-2 pb-3 border-b-third">
        <LiveHelpIcon className="text-third" /> Neue Anfrage
      </h6>

      <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
        <div className="flex">
          <div>
            <h3 className="text-gray-400 font-bold">Buchungsnummer</h3>
            <p>{booking.bookingNumber}</p>
          </div>

          <div className="ml-auto w-1/2">
            <h3 className="text-gray-400 font-bold">Name</h3>
            <p>{booking.bookingUsername}</p>
          </div>
        </div>

        <Controller
          name="email"
          control={control}
          rules={{
            required: "email ist erforderlich",
          }}
          render={({
            field: { onChange, onBlur, value },
            fieldState: { error },
          }) => (
            <TextField
              label="E-Mail Adresse"
              variant="outlined"
              fullWidth
              onChange={onChange}
              onBlur={onBlur}
              error={!!errors.email}
              helperText={errors.email?.message}
              value={value}
            />
          )}
        />

        <Controller
          name="message"
          control={control}
          rules={{
            required: "Nachricht ist erforderlich",
          }}
          render={({
            field: { onChange, onBlur, value },
            fieldState: { error },
          }) => (
            <TextField
              label="Nachricht"
              variant="outlined"
              multiline
              minRows={3}
              fullWidth
              onChange={onChange}
              onBlur={onBlur}
              error={!!errors.message}
              helperText={errors.message?.message}
              value={value}
            />
          )}
        />

        <Controller
          name="taskType"
          control={control}
          rules={{ required: "Bitte wählen Sie ein Thema" }}
          render={({
            field: { onChange, onBlur, value },
            fieldState: { error },
          }) => (
            <FormControl fullWidth error={!!error}>
              <InputLabel id="taskType">Thema</InputLabel>
              <Select
                label="Thema"
                labelId="taskType"
                onChange={onChange}
                onBlur={onBlur}
                value={value}
              >
                <MenuItem key="Flugzeitenänderung" value="Flugzeitenänderung">
                  Flugzeitenänderung
                </MenuItem>
                <MenuItem key="Umbuchung" value="Umbuchung">
                  Umbuchung
                </MenuItem>
              </Select>
              {error && (
                <FormHelperText>
                  {errors.taskType?.message || "Error"}
                </FormHelperText>
              )}
            </FormControl>
          )}
        />

        <button
          type="submit"
          className="w-full p-3 bg-yellow-400 text-black rounded-md hover:bg-yellow-500 focus:outline-none focus:ring focus:ring-yellow-300"
        >
          ABSENDEN
        </button>
      </form>
    </div>
  );
};

export default ChatForm;
